import { CommonProductModel, QteTypes } from '@common/models';

export const buildQteAttributes = (product: CommonProductModel): QteTypes => ({
    qteCode: product.qteCode,
    qteCodeId: product.qteCodeId,
    qteSubCode: product.qteSubCode,
    qteSubCodeId: product.qteSubCodeId,
    qteTypeCode: product.qteTypeCode,
    qteTypeId: product.qteTypeId,
});
